var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0971 15.5352L21.6378 10.5262C21.8969 10.1807 21.9401 9.70575 21.7674 9.27394C21.5946 8.84212 21.2061 8.58303 20.7311 8.53985C20.2561 8.49667 19.8674 8.71258 19.6083 9.05803L18.0971 11.1739L13.4767 17.6943L10.3244 13.9375C9.89261 13.4193 9.07216 13.333 8.55398 13.808C8.03581 14.2398 7.94946 15.0602 8.42445 15.5784L12.6562 20.5443C12.8721 20.8034 13.2175 20.9329 13.563 20.9761H13.6062C13.9085 20.9329 14.2108 20.8034 14.4267 20.5443L14.4698 20.5011C14.5129 20.5011 14.513 20.4579 14.5562 20.4147L18.0971 15.5352ZM18.0971 0.335392C19.3925 0.59448 20.6447 1.06947 21.8538 1.67401C28.6764 5.1717 31.7422 13.2466 28.9787 20.4147C26.2151 27.5828 18.4856 31.4692 11.1016 29.4828C3.71769 27.4965 -0.989031 20.242 0.176857 12.6853C1.12684 6.63987 5.66086 1.76037 11.663 0.37857C13.7789 -0.0964247 15.9812 -0.139603 18.0971 0.335392Z",
    fill: "#4CCD8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checkedCircle.14c61966.svg";
export { ForwardRef as ReactComponent };